import brand from '@helpers/brand';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { fonts } from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import DatePickerStyles from '@stories/Components/Forms/NewDatePicker/DatePicker.styles';
import TextboxStyles from '@stories/Components/Forms/Textbox/Textbox.styles';
import { TextAreaStyles } from '@stories/Components/Forms/TextArea/TextArea.styles';
const Card = styled.div `
  position: relative;
  display: flex;
  padding: 16px;
  background: ${brand.white};
  border: 1px solid ${rgba(brand.black, 0.1)};
  box-shadow: ${rgba(brand.black, 0.16)} 0 4px 10px;
  transition: opacity 375ms ease;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${brand.white};

    ${({ disabled }) => disabled
    ? css `
            opacity: 0.4;
            cursor: progress;
            transition: opacity 100ms ease;
          `
    : css `
            transition: opacity 275ms ease;
            pointer-events: none;
            opacity: 0;
          `};
  }
`;
const Media = styled.div `
  position: absolute;
  top: 16px;
  left: 16px;
  width: 100%;
  max-width: 95px;

  @media ${from(Device.TabletLarge)} {
    max-width: 168px;
    position: unset;
  }

  img {
    display: block;
    width: 100%;
  }
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${from(Device.TabletLarge)} {
    padding-left: 16px;
  }
`;
const Top = styled.div `
  position: relative;
`;
const Bottom = styled.div `
  width: 100%;

  ${DatePickerStyles.Wrapper} {
    margin: 14px 0px;
  }

  input[type='text'],
  ${TextboxStyles.Input} {
    max-width: 332px;

    @media ${from(Device.TabletLarge)} {
      max-width: 295px;
    }
  }

  ${({ marginAuto }) => marginAuto &&
    css `
      margin-top: auto;

      ${() => Text} {
        margin-top: auto;
      }
    `}
`;
const Split = styled.div `
  @media ${from(Device.TabletLarge)} {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
const DeleteButton = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  transition: transform 0.15s ease;

  svg {
    width: 20px;
    height: 25px;
  }

  &:hover {
    transform: rotate(15deg);
  }
`;
const Title = styled.div `
  font-size: 18px;
  line-height: 1.2;
  ${fonts.DaxPro['Medium']};
  color: ${brand.grey.grey20};
  margin-bottom: 6px;
  min-height: 45px;
  padding-left: 110px;
  padding-right: 30px;

  @media ${from(Device.TabletLarge)} {
    font-size: 30px;
    min-height: unset;
    padding-left: unset;
    padding-right: unset;
  }
`;
const Small = styled.small `
  display: block;
  font-size: 16px;
  line-height: 1.2;
  ${fonts.DaxPro['Regular']};
  color: ${brand.grey.grey55};
  padding-left: 110px;
  margin-bottom: 36px;
  min-height: 38px;

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
    padding-left: unset;
    margin-bottom: unset;
    min-height: unset;
  }
`;
const Label = styled.label.attrs({ readonly: 'readonly' }) `
  display: block;
  font-size: 18px;
  ${fonts.DaxPro['Medium']};
  margin-bottom: 6px;
  color: ${brand.grey.grey20};
`;
const Text = styled.div `
  line-height: 1.2;
  font-size: 16px;
  ${fonts.DaxPro['Medium']};
  color: ${brand.primary.base};
  margin: 16px 0 8px;

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
  }

  ${({ desktopOnly }) => desktopOnly &&
    css `
      display: none;

      @media ${from(Device.TabletLarge)} {
        display: block;
        margin: 0;
      }
    `}

  ${({ mobileOnly }) => mobileOnly &&
    css `
      display: block;
      margin-bottom: 10px;

      @media ${from(Device.TabletLarge)} {
        display: none;
      }
    `}
`;
const Field = styled.div `
  margin-bottom: 12px;
`;
const Dates = styled.div `
  display: flex;
  width: 100%;
  flex: 1;
  font-size: 18px;
  ${fonts.DaxPro['Regular']};
  color: ${rgba(brand.grey.grey20, 0.75)};

  > ${Field} {
    flex-basis: 50%;
  }
`;
const Error = styled.p `
  ${ParagraphStyles.Paragraph};
  font-size: 16px;
  color: ${brand.red.base};
  margin: 12px 0px;
`;
const SelectQuantity = styled.div `
  margin: 14px 0px;
`;
const ProductQuestions = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 14px;

  ${TextAreaStyles.Input} {
    max-width: 332px;
    height: 72px !important;
    padding: 13px 18px;
    min-height: unset;
    line-height: 1.2;

    @media ${from(Device.TabletLarge)} {
      max-width: 295px;
    }
  }
`;
export const HireCardStyles = {
    Card,
    Media,
    Content,
    Top,
    Bottom,
    Split,
    Title,
    Small,
    Label,
    Text,
    Dates,
    Field,
    SelectQuantity,
    ProductQuestions,
    DeleteButton,
    Error,
};
